export type RegulationCapabilityAvailability = 'optional' | 'comingSoon'

export type RegulationCapabilityKey =
  | 'validateDesignAndConstruction'
  | 'validateMarkingsAndInstructions'

export type RegulationCapabilityConfig = {
  key: RegulationCapabilityKey
  availability: RegulationCapabilityAvailability
}

export const LVD_REGULATION_CAPABILITIES: readonly RegulationCapabilityConfig[] =
  [
    {
      key: 'validateDesignAndConstruction',
      availability: 'comingSoon',
    },
    {
      key: 'validateMarkingsAndInstructions',
      availability: 'comingSoon',
    },
  ]
